<div class="bg-light min-vh-100 d-flex align-items-center">
    <div class="mx-auto w-100" style="max-width: 480px; padding: 16px;">
        <c-card>
            <c-card-body class="p-4 text-center">
                <svg cIcon name="cilWarning" size="3xl" class="text-warning mb-3"></svg>
                <h4 class="mb-2">Organization not found</h4>
                <p class="text-muted mb-4">
                    The organization you're looking for doesn't exist or you don't have
                    permission to access it.
                </p>
                <p class="text-muted mb-0">
                    Press Any Key to Return To The
                    <button (click)="goToMainMenu()" cButton color="primary" size="sm">Main Menu</button>
                </p>
            </c-card-body>
        </c-card>
    </div>
</div>
